module.exports = __webpack_public_path__ + "static/media/Bitcoin-Cash-BCH-icon.46ca60df.png";